import { event } from '@/lib/google-analytics';
import { project } from '@/lib/project';
import { cn } from '@/lib/utils';
import { PlayIcon } from '@heroicons/react/24/solid';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { GoogleAdUnit } from '../@google/GoogleAdUnit';

const BottomDialog = dynamic(() =>
	import('@/components/ui/BottomDialog', { ssr: false })
);

export default function VideoPlayer({
	videoTitle,
	videoId,
	enableAds = false,
	className,
	isImagePriority = false,
	videoClassName,
	coverClassName,
	titleClassName,
	showTitle = true,
	showPlayButton = false,
}) {
	const router = useRouter();
	const [isPlaying, setIsPlaying] = useState(false);

	const handleVideoClick = () => {
		setIsPlaying(true);
		event('video_click', { label: videoTitle, category: router.pathname });
	};

	const imageSrc = `https://i.ytimg.com/vi/${videoId}/maxresdefault.jpg`;

	return (
		<>
			<div
				className={cn('group space-y-3', className)}
				onClick={() => handleVideoClick()}
			>
				<div
					className={cn(
						'min-w-56 relative aspect-video overflow-hidden rounded-lg',
						videoClassName
					)}
				>
					<Image
						alt={videoTitle || videoId}
						// width={828}
						// height={446}
						priority={isImagePriority}
						sizes={
							'(min-width: 1360px) 797px, (min-width: 1040px) calc(53.33vw + 82px), calc(100vw - 40px)'
						}
						fill
						className={cn(
							'scale-x-[101%] object-cover transition-all duration-200 group-hover:scale-110 group-hover:cursor-pointer',
							coverClassName
						)}
						// className="size-full my-0! absolute inset-0 cursor-pointer object-cover "
						src={imageSrc}
						onError={(e) => {
							e.target.src = `/images/placeholder.svg`;
							e.target.srcset = `/images/placeholder.svg`;
						}}
					/>
					{showPlayButton && (
						<div className="max-w-20 pointer-events-none absolute inset-0 m-auto flex h-[40%] max-h-14 w-[50%] items-center rounded-xl border-red-900 bg-red-600 drop-shadow-md">
							<PlayIcon className="size-[50%] max-w-9 m-auto max-h-9 fill-white" />
						</div>
					)}
				</div>
				{videoTitle && showTitle && (
					<h3
						className={cn(
							'line-clamp-3 text-sm font-semibold leading-tight group-hover:cursor-pointer group-hover:underline',
							titleClassName
						)}
					>
						<span
							dangerouslySetInnerHTML={{
								__html: videoTitle.split('#')[0],
							}}
						/>
					</h3>
				)}
			</div>
			<BottomDialog
				title={videoTitle}
				onClose={() => setIsPlaying(false)}
				isOpen={isPlaying}
			>
				<iframe
					src={`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&playsinline=0`}
					title={'Video Player'}
					className="aspect-video w-full"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
					referrerPolicy="strict-origin-when-cross-origin"
				></iframe>
				{enableAds && (
					<GoogleAdUnit
						containerClassName={'max-h-[90px] w-full mt-2'}
						slotId={project.adSense.video}
						adFormat={'horizontal'}
					/>
				)}
			</BottomDialog>
		</>
	);
}
